// extracted by mini-css-extract-plugin
export default {"itemsContainer":"Login_itemsContainer__WPcmp","image":"Login_image__hA0-m","button":"Login_button__f0iz6"};